export default "__VITE_ASSET__DOtpI7zz__"